import React from "react";

export default function HeadingNote() {
    return (
        <>
            <div className="bg-sky-400 shadow-md shadow-lime-600 text-center font-black py-8 text-2xl rounded-lg">
                Pokemon Info Cards
            </div>
        </>
    );
}